<template lang="pug">
    .container.mx-auto.spacingTopStandard.spacingBottomStandard
      table.table.table-auto
       tbody
          tr
            td(width='330') 1997
            td(width='495') Abreu Cabernet Sauvignon Madrona Ranch
          tr
            td 2002
            td Abreu Cabernet Sauvignon Thorevilos
          tr
            td 2005; 2006
            td Alban Vineyards Syrah Lorraine
          tr
            td 2005; 2006
            td Alban Vineyards Syrah Reva Alban Estate
          tr
            td 2004
            td Artadi Vina El Pison
          tr
            td 2004; 2005
            td Benjamin Romeo Contador
          tr
            td 2004
            td Bodegas Fernando Remirez de Ganuza Gran Reserva
          tr
            td 1989
            td Bruno Giacosa Barolo Riserva Collina Rionda
          tr
            td 1997
            td Bryant Family Vineyard Cabernet Sauvignon
          tr
            td 1991
            td Chapoutier Cote Rotie la Mordoree
          tr
            td 2000
            td Chapoutier Ermitage Cuvee de l’Oree
          tr
            td 2003
            td Chapoutier Ermitage l’Ermite
          tr
            td 1999; 2000; 2003; 2004; 2006
            td Chapoutier Ermitage l’Ermite Blanc
          tr
            td 2004
            td Chapoutier Ermitage le Meal Blanc
          tr
            td 1989; 1990; 1991; 2003
            td Chapoutier Ermitage le Pavillon
          tr
            td 2003; 2005
            td Chateau Ausone
          tr
            td 1990
            td Chateau Beausejour (Duffau Lagarrosse)
          tr
            td 1989; 1990; 1998; 2007
            td Chateau Beaucastel Chateauneuf du Pape Hommage A Jacques Perrin
          tr
            td 1947; 2000
            td Chateau Cheval Blanc
          tr
            td 2001
            td Chateau Climens
          tr
            td 1989
            td Chateau Clinet
          tr
            td 1811; 1847; 2001
            td Chateau d’Yquem
          tr
            td 2007
            td Chateau de Saint Cosme Gigondas Hominis Fides
          tr
            td 1945; 1961; 1989
            td Chateau Haut Brion
          tr
            td 2000
            td Chateau La Clusiere
          tr
            td 1995
            td Chateau Tirecul la Graviere Cuvee Madame
          tr
            td 1955; 1959; 1975; 1982; 2000
            td Chateau La Mission Haut Brion
          tr
            td 1996; 2003
            td Chateau Lafite Rothschild
          tr
            td 1945; 1947; 1950; 1975; 1982; 2000
            td Chateau Lafleur
          tr
            td 1961; 1982
            td Chateau Latour
          tr
            td 1947; 1961
            td Chateau La Tour a Pomerol
          tr
            td 1921; 1947; 2005
            td Chateau L’Eglise Clinet
          tr
            td 1982
            td Chateau Le Pin
          tr
            td 1982
            td Chateau Leoville Las Cases
          tr
            td 1900; 1990; 2000
            td Chateau Margaux
          tr
            td 1990
            td Chateau Montrose
          tr
            td 1945; 1959; 1982; 1986
            td Chateau Mouton Rothschild
          tr
            td 2000
            td Chateau Pavie
          tr
            td 1921; 1929; 1947; 1961; 1989; 1990; 2000
            td Chateau Petrus
          tr
            td 1982
            td Chateau Pichon Longueville Comtesse de Lalande
          tr
            td 1990; 2003
            td Chave Hermitage Cuvee Cathelin
          tr
            td 2003
            td Chave Hermitage
          tr
            td 1996; 1998; 2001; 2002; 2004
            td Chris Ringland (formerly Three Rivers) Shiraz
          tr
            td 2004; 2005
            td Clos I Terrasses Clos Erasmus
          tr
            td 2005; 2007
            td Clos Saint Jean Chateauneuf du Pape Deus Ex Machina
          tr
            td 2007
            td Clos Saint Jean Chateauneuf du Pape la Combe des Fous
          tr
            td 2007
            td Clos Saint Jean Chateauneuf du Pape Sanctus Sanctorum
          tr
            td 2002
            td Colgin Cabernet Sauvignon Tychson Hill
          tr
            td 2006; 2007
            td Colgin IX
          tr
            td 1992
            td Dalla Valle Maya Proprietary Red Wine
          tr
            td 1993
            td Domaine Claude et Maurice Dugat Griotte Chambertin
          tr
            td 2001
            td Domaine de la Mordoree Chateauneuf du Pape Cuvee de la Reine des Bois
          tr
            td 1990
            td Domaine de la Romanee Conti La Tache
          tr
            td 1986
            td Domaine de la Romanee Conti Montrachet
          tr
            td 1929
            td Domaine de la Romanee Conti Richebourg
          tr
            td 1985
            td Domaine de la Romanee Conti Romanee Conti
          tr
            td 2001; 2003; 2005
            td Domaine de la Vieille Julienne Chateauneuf du Pape Reserve
          tr
            td 2007
            td Domaine de Saint Prefert Chateauneuf du Pape Collecion Charles Giraud
          tr
            td 2001
            td Domaine du Clos du Caillou Chateauneuf du Pape Reserve le Clos du Caillou
          tr
            td 1998; 2000
            td Domaine du Pegau Chateauneuf du Pape Cuvee da Capo
          tr
            td 1991
            td Domaine Leroy Latricieres Chambertin
          tr
            td 2001
            td Domaine Roger Sabon Chateauneuf du Pape le Secret de Sabon
          tr
            td 2001
            td Domaine Weinbach Gewurztraminer Furstentum Quintessence de Grains Nobles
          tr
            td 1990
            td Domaine Zind Humbrecht Gewurztraminer Heimbourg Vendange Tardive
          tr
            td 1989; 1990
            td Domaine Zind Humbrecht Pinot Gris Clos Windsbuhl Vendange Tardive
          tr
            td 1990
            td Domaine Zind Humbrecht Tokay Pinot Gris Clos Jebsal Selection de Grains Noble
          tr
            td 1998; 2002
            td Greenock Creek Cabernet Sauvignon Roennfeldt Road
          tr
            td 2001; 2003
            td Greenock Creek Shiraz Creek Block
          tr
            td 1995; 1996; 1998; 2002
            td Greenock Creek Shiraz Roennfeldt Road
          tr
            td 1985; 1988; 1990; 1998; 1999; 2003; 2005
            td Guigal Cote Rotie la Landonne
          tr
            td 1976; 1978; 1983; 1985; 1988; 1991; 1999; 2003; 2005
            td Guigal Cote Rotie la Mouline
          tr
            td 1985; 1988; 1999; 2003; 2005
            td Guigal Cote Rotie la Turque
          tr
            td 2003
            td Guigal Hermitage Ex Voto
          tr
            td 1994; 1997; 2001; 2002
            td Harlan Estate
          tr
            td 1990
            td Henri Bonneau Chateauneuf du Pape Reserve des Celestins
          tr
            td 2001; 2002; 2004
            td Hermann Dönnhoff Riesling Eiswein Oberhauser Brücke
          tr
            td 1947
            td Jose Maria da Fonseca Moscatel de Setubal
          tr
            td 2007
            td Kapcsandy Cabernet Sauvignon State Lane
          tr
            td 1990
            td Les Cailloux (Lucien et Andre Brunel) Chateauneuf du Pape Cuvee Centenaire
          tr
            td 2007
            td Mas de Boislauzon Chateauneuf du Pape Cuvee du Quet
          tr
            td 1999
            td Michel Ogier Cote Rotie Cuvee Belle Helene
          tr
            td 2004
            td Numanthia Termanthia
          tr
            td 2002
            td Paul Hobbs Cabernet Sauvignon Beckstoffer To Kalon
          tr
            td 1961; 1978; 1990
            td Paul Jaboulet Aine Hermitage la Chapelle
          tr
            td 1976
            td Penfolds Grange
          tr
            td 2007
            td Pierre Usseglio Chateauneuf du Pape Cuvee de Mon Aieul
          tr
            td 2007
            td Pierre Usseglio Chateauneuf du Pape Reserve des Deux Freres
          tr
            td 2004
            td Pingus
          tr
            td 2002; 2003; 2005; 2007
            td Quilceda Creek Cabernet Sauvignon
          tr
            td 1997
            td Quinta do Noval Vintage Port
          tr
            td 1999
            td Rene Rostaing Cote Rotie Cote Blonde
          tr
            td 2007
            td Saxum James Berry
          tr
            td 2007
            td Scarecrow Cabernet Sauvignon
          tr
            td 2007
            td Schloss Lieser Brauneberger Juffer Sonnenuhr Auslese Long Goldkapsel
          tr
            td 2006; 2007
            td Schrader Cellars Cabernet Sauvignon
          tr
            td 2006; 2007
            td Schrader Cellars Cabernet Sauvignon Old Sparky
          tr
            td 1997
            td Screaming Eagle Cabernet Sauvignon
          tr
            td 1909
            td Seppeltsfield Para Port Vintage Tawny
          tr
            td 2002
            td Shafer Vineyards Cabernet Sauvignon Hillside Select
          tr
            td 2005
            td Sine Qua Non Mr K The Strawman Marsanne
          tr
            td 2005
            td Sine Qua Non The 17th Nail In My Cranium
          tr
            td 2000
            td Sine Qua Non Suey TBA
          tr
            td 2004
            td Sine Qua Non Mr K The Strawman
          tr
            td 2005
            td Sine Qua Non Atlantis Fe 203 1A
          tr
            td 2006
            td Sine Qua Non A Shot In The Dark
          tr
            td 2004
            td Sine Qua Non Poker Face
          tr
            td 2002
            td Sine Qua Non Just For The Love Of It
          tr
            td 2003
            td Sine Qua Non The Inaugural
          tr
            td 2002
            td Sloan
          tr
            td 1992
            td Taylor Fladgate Vintage Port
          tr
            td 1985
            td Tenuta San Guido Sassicaia
          tr
            td 2000
            td Tua Rita Redigaffi
          tr
            td 2007
            td Verite La Joie


</template>

<script>
export default {
    name: 'Table1'
    // Robert Parker – 100 Punkte Weine
};
</script>

<style lang="sass" scoped>
.table
  @apply table w-full

  tr:nth-child(odd)
    @apply bg-gray-100

  &:first-child
    td
    @apply border-t
  td, th
    @apply border-b border-r
    padding: 6px 10px
    &:first-child
      @apply border-l
</style>
